import { Context, type Effect } from "effect";
import type { StationClientFailure, StationWritten } from "../../api/station/model.ts";
import type { CurrentSession, SessionMembers } from "./session-model.ts";

export interface StationSessionShape {
  readonly persist: (stationId: string, members: SessionMembers) => Effect.Effect<StationWritten, StationClientFailure>;
  readonly mutate: (stationId: string, change: (current: CurrentSession) => Effect.Effect<CurrentSession, StationClientFailure>) => Effect.Effect<CurrentSession, StationClientFailure>;
}
export class StationSession extends Context.Service<StationSession, StationSessionShape>()("workerstation/frontend/StationSession") {}
